import { render } from "./APIIntegration.vue?vue&type=template&id=d78c4c2a"
import script from "./APIIntegration.vue?vue&type=script&lang=js"
export * from "./APIIntegration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__